import React from "react";
import { NavLink } from "react-router-dom";
import { useSelector } from "react-redux";
import configData from "../config.json";

const Navbar = () => {
  const cartItems = useSelector((state) => state.handleCart);

  return (
    <nav
      className="navbar navbar-expand-lg navbar-dark sticky-top shadow-sm" style={{background: "linear-gradient(90deg, #2c3e50, #4b79a1)"}}>
      <div className="container">
        {/* Logo */}
        <NavLink className="navbar-brand d-flex align-items-center gap-2" to="/">
		{/*<img src={`${configData.IMAGE_URL}/bseceshop.png`} height="45" alt="Logo"/>*/}
          <img src={`${configData.IMAGE_URL}/logo.png`} height="45" alt="Logo"/>
          <span className="fw-bold fs-5 text-white">BSEC eShop</span>
        </NavLink>

        {/* Mobile Toggle */}
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#mainNavbar"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* Menu */}
        <div className="collapse navbar-collapse" id="mainNavbar">
          <ul className="navbar-nav mx-auto text-center gap-lg-3">
            <li className="nav-item">
              <NavLink className="nav-link" to="/">
                <img
                  src={`${configData.IMAGE_URL}/logoGovt.png`}
                  height="40"
                  alt="Govt Logo"
                />
              </NavLink>
            </li>

            <li className="nav-item">
              <NavLink
                className={({ isActive }) =>
                  "nav-link fw-semibold " + (isActive ? "active text-warning" : "")
                }
                to="/"
              >
                Products
              </NavLink>
            </li>

            <li className="nav-item">
              <NavLink
                className={({ isActive }) =>
                  "nav-link fw-semibold " + (isActive ? "active text-warning" : "")
                }
                to="/about"
              >
                About
              </NavLink>
            </li>

            <li className="nav-item">
              <NavLink
                className={({ isActive }) =>
                  "nav-link fw-semibold " + (isActive ? "active text-warning" : "")
                }
                to="/contact"
              >
                Contact
              </NavLink>
            </li>

            <li className="nav-item">
              <NavLink
                className={({ isActive }) =>
                  "nav-link fw-semibold " + (isActive ? "active text-warning" : "")
                }
                to="/faq"
              >
                FAQ
              </NavLink>
            </li>
          </ul>

          {/* Right Side Actions */}
          <div className="d-flex align-items-center gap-3">
            {/* Login */}
            <NavLink
              to="/login"
              className="btn btn-outline-light btn-sm px-3"
            >
              Login
            </NavLink>

            {/* Cart */}
            <NavLink to="/cart" className="position-relative text-white">
              <i
                className="fa fa-shopping-cart"
                style={{ fontSize: "22px" }}
              ></i>

              {/* Badge */}
              {cartItems.length > 0 && (
                <span
                  className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
                  style={{ fontSize: "10px" }}
                >
                  {cartItems.length}
                </span>
              )}
            </NavLink>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;